module.exports = __webpack_public_path__ + "img/handraw_information.8894bc9c.svg";